import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import { ToothSurface } from '../../../../../graphql/graphql';

export const Tooth84: ToothDataEntry = {
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M183.6,125.3c-7.5-13.9-29.9-22.7-29.9-22.7l.3-12.9c14.9-.2,28.6-13.9,28.6-13.9l4.2,9.9,2.2,9,.2,16-5.5,14.5h-.1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M60.2,88.8c-17-1.4-31.9-12.4-31.9-12.4l-1.3,9.7.7,7v5.3s1,8.5,1,8.5l2,8.2c9.2-16.2,30.1-13.7,30.1-13.7l-.5-12.7h-.1Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M154,102.5l.3-12.9s-10.7.2-19.6-4.4-19.8-10.2-26.4-10.2c-11.1,0-17.9,5.1-25.8,9.1s-22.1,4.8-22.1,4.8l.5,12.7s12.7,0,19.3,4.6c4.6,3.1,15.5,8.5,25.1,8.5,9.6,0,17.8-3.4,28.2-7.8,10.4-4.4,20.3-4.4,20.3-4.4h.2Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M183.7,125l-2.5,4.2-5.1,5.4-8.8,6.7-8.8,5.9-9.5,4.8-10,3s-9.3,1.1-9.3,1.2h-8.2s-6.7.9-6.7.9l-6.9,1.3-3.1,1c-7.2-25.8.5-44.7.5-44.7,0,0,7.8,1.2,28.2-7.8,10.7-4.7,20.3-4.4,20.3-4.4,24.6,10.4,29.9,22.7,29.9,22.7v-.2Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M105.5,114.7c-7.8,23.4-.5,44.7-.5,44.7l-7,2.6h-13s-11.6-3.1-11.6-3.1l-9.3-2.8-5-2.5-6.1-4.8-3.6-2.8-8.1-6.6-3.9-4.4-3-5.5-2.3-7.6-1.2-6.6c4.9-15.4,35-17.8,49.3-9.1,14.3,8.7,25.1,8.5,25.1,8.5h.2Z',
			},
			[ToothSurface.MesioLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M154.1,89.7c-5.9,0-11.6-1.1-19.6-4.4-17.8-10.5-27-10.2-27-10.2-8.2-35.2,3.2-46.8,3.2-46.8l5.6.5,9.7,1.9,6.8,1.8,8.3,2.7,9.5,4.3,7.1,4.5,7.5,6,6.2,5.8,5.3,6.9,2.4,5,3.6,8.1s-13.3,13.9-28.6,13.9Z',
			},
			[ToothSurface.DistoLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M110.7,28.3c-11.5,17.4-3.2,46.8-3.2,46.8-10.8-.2-20.6,7.3-25.1,9.1s-4.8,6.4-22.1,4.8-31.9-12.4-31.9-12.4l.6-4.1,1.4-3.6,1.6-3.4,2.8-4.5,3.1-4.2,3.6-3.9,4-4.5,5.6-5.1,6-4.2,5.2-3.2,4.8-2.4,5.3-2.4,5.9-1.7,9-1.4,23.4.3h0Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M124,155.2c-14.5.1-25.9,9.4-40.1,5.8-8.2-2.1-17.3-3.8-24.7-8.2-4.6-2.7-8.3-7.1-12.8-10.1-6.4-4.3-10.6-9.8-12.8-17.2s-4.7-14.1-5.1-21.5l-1.1-21.1c-.3-6.1,2.6-12.8,5.7-18.1,8.2-14.6,21.3-24.6,36.1-31.8s30.1-5,44.1-4c12.2.8,23.6,4.3,34.8,9.3s13.4,8.8,19.8,14.2c11.5,9.8,19.7,32,21.1,47.6.9,9.4-1.9,21.2-8.1,28.5s-17.8,15.7-28,20.6c-9.2,4.5-18.8,5.9-28.6,6Z',
			},
		},
	},
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M129.9,437.2A12.6,12.6 0 1 0 104.7,437.2A12.6,12.6 0 1 0 129.9,437.2Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M156.6,474.3l4.4-2.7,7.7-6.8,9.3-6.5,9.7-6.6,7-5.9,1.3-3.1v-19.1s-28.7,0-28.7,0c-10.5,0-10.8,9.8-10.8,9.8v40.9s0,0,0,0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M44,423.9s15.2-.4,26.3-.4c11.1,0,10.1,10.7,10.1,10.7v43.6s-10.2-.2-10.2-.2l-7.8-5-7.4-7.2-3.8-6.2-2.9-6.7-3.7-6.4-2.2-6.9v-5.8s1.7-9.6,1.7-9.6h-.1Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M188.9,374.6l-1.4-8.1s-37.9,25.8-66.8,27.8c-26.5,1.8-66.9-15.2-66.9-15.2l-.4,9.1s39.4,15.8,66,15.8c26.6,0,69.4-29.4,69.4-29.4h0Z',
			},
			[ToothSurface.MesioLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M117.1,465.4c-4.3-42.7,2.2-61.2,2.2-61.2,28-1.2,69.4-29.4,69.4-29.4l1.4,11,3.1,13,2,13.3.7,11.6v19.1s-1.4,3.4-1.4,3.4l-4.5,3.6-7.9,5.6-11.9,8.1-13.8,10.8-4.6,2.3h-7.9s-4-.9-4-.9l-4.4-1.2-5.8-3-2.3-2.8-10.2-3.5v.2Z',
			},
			[ToothSurface.DistoLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M53.3,388.3c45.8,17,66,15.8,66,15.8-6.6,25.2-2.2,61.2-2.2,61.2l-2.5-.8-3.8-1.2-3.3-1.1-3.3,2.8-5.3,5.8-4.8,2.2-6.6,1.9-7.1,2.8-10.2-.2-7.8-5-7.4-7.2-3.8-6.2-2.7-6-3.9-7.1-2.2-6.9v-6.2s1.7-9.1,1.7-9.1l1-5.7,1.4-8.8,4.6-13.4,2.3-7.7h-.1Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M106.5,461.1c-4.9,9.2-12.2,10.7-19.8,13.7s-14.9,4-22.2-1.4c-7.7-5.7-12.5-13.7-16.8-22.1s-5.9-12.4-4.6-20.4c2.1-12.9,4.1-25.5,9.3-37.6s1.2-6.9,1.6-11.4c39.4,38.8,93.5,20.6,133.8-9.7l2.7,15.5c4.4,18.3,6.8,36.8,5.1,55.5-3.5,4.9-8.1,8.4-13.2,11.2s-13,8.6-18.8,14.2c-11.6,11.2-24.2,9.1-37.2.2l-19.8-7.6Z',
			},
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M124.3,80.7A11.4,11.4 0 1 0 101.5,80.7A11.4,11.4 0 1 0 124.3,80.7Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M183.6,121.7l-1.8,10.7s-28.7,26.2-71.8,11c-30.9-10.9-66.3-19.7-66.3-19.7l-.8-7.2s2.5-2.7,68.2,18.8c50.3,16.5,72.4-13.6,72.4-13.6h.1Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M189,77.4s-15.8-.4-30.2-.4-13.5-15.5-13.5-15.5V24.9s6.1,1.4,6.1,1.4l9.9,2.5,6.7.4,6,1.4,5.3,4.7,5.8,9.9,3.4,10.3.5,22h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M64.2,39.1s-.1,21.6-.1,29.6c0,8-8.7,8.2-8.7,8.2h-21.4v-3.7s1.6-8.7,1.6-8.7l1.7-10.1,1.5-5.7,1.7-4.2,4.1-5.3,3.6-1.7,6.2-.4,9.7,2.1h0Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M111.7,30.9l20.6-7.9,7.8.2,5.2,1.8,16,3.8,6.7.4,6,1.4,5.3,4.7,5.8,9.9,3.4,10.2s.5,22,.4,22v13.3s-1,5.1-1,5.1l-.7,7-1.2,5.5-1.5,8.2-.9,5.2c-26.9,31.6-71.9,13.7-71.9,13.7-10.3-34.9,0-104.6,0-104.6h0Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M111.8,30.7c-10.2,76,0,104.6,0,104.6-64.2-20.6-68.8-18.9-68.8-18.9l-3.6-6.5-2.9-8.6-2.3-10.5v-18.2s1.2-7.4,1.2-7.4l1.9-10.6,1.5-5.9,1.7-4.2,3.9-5.1,3.7-1.9,6.3-.4,9.7,2.1,7.3.9,4.1-2.2,9.5-2,14.9-2.8,11.8-2.3h.1Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M98.6,124.9c-10.9-10.3-40.4-12.7-58-13.8-9.5-20.9-6.7-41.3-1-63.7,1.3-4.9,7-9.7,12-9.4s10.2.9,14.9,1.9,5.4.2,9.1-1.1c10.3-3.7,21.6-4.2,32.4-6.5l21.6-7.3c3.2-1.1,7.7-1,11.3-.3l22.9,4.6c8.5.4,14.3,4.3,18.3,11.6,3.7,6.8,6.1,13.7,6.1,21.8v25.1c.2,13.5-3.7,26.3-5.7,39.6-7.9,6.2-15.7,11.2-24.5,15.5-21.4,10.6-42.5-2-59.5-18.1Z',
			},
		},
	},
};
